import React from "react";

import { Container, Row, Col } from "reactstrap";
import { useNavigate } from "react-router-dom";

import BaseButton from "../../common/BaseButton";
import HeroSection from "../../common/HeroSection";
import heroAboutUsImg from '../../../assets/images/heroAboutUs.png';
// import teamMembersArc from '../../../assets/images/teamMembersArc.png';
// import teamMembersArcMobile from '../../../assets/images/servicesArcMobile.png';
import teamsFirst from '../../../assets/images/teamsFirst.png';
import teamsSecond from '../../../assets/images/teamsSecond.png';
import teamsThird from '../../../assets/images/teamsThird.png';
import reactImage from '../../../assets/images/reactImage.png';

import './style.scss'; 

export default function AboutUs () {
    let navigate = useNavigate();
    
    return (
        <Container fluid className="about-us-page">
            <HeroSection
                title={'Driven by Your Success, Fueled by Our Expertise'}
                description={'DevsMore was founded on the belief that every business deserves access to quality IT talent, no matter its size. We’re not here to impose solutions but to bring your vision to life. Our experienced team of designers, developers, and QA specialists stands ready to support your goals, whether you’re a startup building from scratch or an established business looking to expand.'}
                icon={heroAboutUsImg}
                isTopArc
            />
            {/* //TODO delete when project is over */}
            {/* <Row className="team-members">
                <Col xs={12}>
                    <h2 className="heading-2">
                        The brains behind the name
                    </h2>
                    <img src={teamMembersArcMobile} className="team-members-arc-mobile" alt="team members arc"/>
                </Col>
                <Col xs={12} md={3} className="team-member"> 
                    <div className="person-img"/>
                    <h3 className="heading-3">
                        Darina Yanakieva
                    </h3>
                    <p className="body-text">Co founder & CEO</p>
                    <p className="body-text">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text.</p>
                    <div className="linked-in"/>
                </Col>
                <Col xs={12} md={{offset: 1,size: 3}}  className="team-member"> 
                    <div className="person-img"/>
                    <h3 className="heading-3">
                        Alexander Sergiev
                    </h3>
                    <p className="body-text">Co founder & CEO</p>
                    <p className="body-text">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text.</p>
                    <div className="linked-in"/>
                </Col>
                <img src={teamMembersArc} className="team-members-arc" alt="team members arc"/>
            </Row> */}
            <Container>
                <Row className="teams-images">
                    <Col xs={12} md={{offset: 2,size: 8}}>
                        <h2 className="heading-2">You can always count on our teams during your journey</h2>
                    </Col>
                    <Col
                        xs={12}
                        md={5}
                        style={{background: `url(${teamsFirst})`}}
                        className="teams-col"
                    />
                    <Col xs={12} md={7}>
                        <Row>
                            <Col 
                                xs={12}
                                style={{background: `url(${teamsSecond})`}}
                                className="teams-col"
                            />
                        </Row>
                        <Row>
                            <Col 
                                xs={12}
                                style={{background: `url(${teamsThird})`}}
                                className="teams-col"
                            />
                        </Row>
                    </Col>
                </Row>
            </Container>
            <Row className="curious-about-us">
                <Col xs={12} md={7}>
                    <h2 className="heading-2">Curious about how we can fit into your team? Let’s discuss your needs!</h2>
                    <BaseButton onClick={() => navigate('/contacts')}/>
                </Col>
                <Col className="curious-img" xs={12} md={5}>
                    <img src={reactImage} className="react-image" alt="react-image"/>
                </Col>
            </Row>
        </Container>
    )
}
